import { Controller } from "@hotwired/stimulus"

// Shows/hides discount inputs with a Bootstrap toggle while keeping values sticky
export default class extends Controller {
  static targets = ["fields", "toggle", "typeSelect", "valueInput"]

  initialize() {
    this.previousType = null
    this.previousValue = null
  }

  connect() {
    this.applyState()
  }

  toggle() {
    this.applyState()
  }

  handleTypeChange(event) {
    const enabled = event.target.value !== "none"
    this.toggleTarget.checked = enabled
    this.applyState()
  }

  applyState() {
    if (!this.hasToggleTarget || !this.hasFieldsTarget) return

    const enabled = this.toggleTarget.checked
    this.fieldsTarget.classList.toggle("d-none", !enabled)

    if (enabled) {
      this.enableField(this.typeSelectTarget)
      this.enableField(this.valueInputTarget)
      this.restorePreviousValues()
    } else {
      this.storeCurrentValues()
      this.setNoDiscount()
      this.disableField(this.typeSelectTarget)
      this.disableField(this.valueInputTarget)
    }
  }

  storeCurrentValues() {
    if (this.hasTypeSelectTarget && this.typeSelectTarget.value !== "none") {
      this.previousType = this.typeSelectTarget.value
    }

    if (this.hasValueInputTarget && this.valueInputTarget.value !== "") {
      this.previousValue = this.valueInputTarget.value
    }
  }

  restorePreviousValues() {
    if (this.hasTypeSelectTarget && this.typeSelectTarget.value === "none" && this.previousType) {
      this.typeSelectTarget.value = this.previousType
    }

    if (this.hasValueInputTarget && !this.valueInputTarget.value && this.previousValue) {
      this.valueInputTarget.value = this.previousValue
    }
  }

  setNoDiscount() {
    if (this.hasTypeSelectTarget) {
      this.typeSelectTarget.value = "none"
    }

    if (this.hasValueInputTarget) {
      this.valueInputTarget.value = ""
    }
  }

  disableField(field) {
    if (field) field.disabled = true
  }

  enableField(field) {
    if (field) field.disabled = false
  }
}
